import {FilterTypes} from "../../../control_produccion/components/FilterTypes";

export default {
    orderStates:[
        {id:1, descrip:'Pendiente' },
        {id:2, descrip:'En produccion' },
        {id:3, descrip:'Terminado' }
    ],
    //Ordenes pendientes no tienen linea de produccion seleccionada
    orderReferences:[],
    histories:[],
    activeModals:[],

    kanban:[],
    tempKanban:[],
    kanbanPendingOrderReferences: [], // Utilizado si la pool de ordenes pendientes es comun entre toda slas lineas de produccion

    calendar:[],
    calendarEvents: [],
    ...(FilterTypes && Object.values(FilterTypes).reduce((res, elem) =>({...res, [elem]:null}), {})),

    lastUpdateTime: 'HH:MM:SS',
    queueEditActive: false,

    showKanbanContainerOverlay: false,
    isMenuShowing: false,
}
